export default __webpack_public_path__ + "static/media/air-purifier-sticker.11ddab60.png";